import { createSelector } from '@reduxjs/toolkit'

const getStateLiquidationsDownload = state => state.liquidationDownload

export const getLiquidationsDownload = createSelector(
  [getStateLiquidationsDownload],
  product => product
)
